(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complementary-products"] && !Shopify.designMode) return;
  try {
    
/* <najibs-recommendations> — shared with sections/product-recommendations.liquid.
   Defined once; the guard keeps the concatenated section bundle idempotent. */
(function () {
  if (window.customElements.get('najibs-recommendations')) return;

  class NajibsRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true' || !this.dataset.url) return;
      if (this.querySelector('[data-recommendations-inner]')) return;

      const load = () => {
        this.dataset.loaded = 'true';
        fetch(this.dataset.url)
          .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
          .then((text) => {
            const parsed = new DOMParser().parseFromString(text, 'text/html');
            const source = parsed.querySelector('najibs-recommendations');
            if (!source || !source.innerHTML.trim()) return;
            this.innerHTML = source.innerHTML;
            if (window.NAJIBS && window.NAJIBS.initReveals) window.NAJIBS.initReveals(this);
          })
          .catch(() => {
            /* no pairings, no section — the page is complete without it */
          });
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              observer.disconnect();
              load();
            });
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        observer.observe(this);
      } else {
        load();
      }
    }
  }

  /* Both this section and its sibling ship the same element. Whichever loads first
     wins the registration; defining it twice would throw NotSupportedError and leave
     the second section permanently empty. */
  if (!window.customElements.get('najibs-recommendations')) {
    window.customElements.define('najibs-recommendations', NajibsRecommendations);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
/* <najibs-recommendations> — fetches Shopify's recommendation route on approach and
   swaps in the server-rendered result. Defined once; both the recommendations and the
   complete-the-look sections share it. */
(function () {
  if (window.customElements.get('najibs-recommendations')) return;

  class NajibsRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true' || !this.dataset.url) return;
      if (this.querySelector('[data-recommendations-inner]')) return;

      const load = () => {
        this.dataset.loaded = 'true';
        fetch(this.dataset.url)
          .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
          .then((text) => {
            const parsed = new DOMParser().parseFromString(text, 'text/html');
            const source = parsed.querySelector('najibs-recommendations');
            if (!source || !source.innerHTML.trim()) return;
            this.innerHTML = source.innerHTML;
            if (window.NAJIBS && window.NAJIBS.initReveals) window.NAJIBS.initReveals(this);
          })
          .catch(() => {
            /* recommendations are an enhancement — the page stands without them */
          });
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              observer.disconnect();
              load();
            });
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        observer.observe(this);
      } else {
        load();
      }
    }
  }

  /* Both this section and its sibling ship the same element. Whichever loads first
     wins the registration; defining it twice would throw NotSupportedError and leave
     the second section permanently empty. */
  if (!window.customElements.get('najibs-recommendations')) {
    window.customElements.define('najibs-recommendations', NajibsRecommendations);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
